module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm7-043181c6d2a1b7d6bcddb97b9327d658.png";